// Debug script to identify store ID mismatch issue
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        console.group('🔍 Store Picker Debug Analysis');
        
        // Get store picker element
        const storePicker = document.querySelector('store-picker');
        if (!storePicker) {
            console.error('Store picker not found');
            console.groupEnd();
            return;
        }
        
        // Get all store items from the picker
        const pickerStores = storePicker.querySelectorAll('li[data-store-id]');
        console.log(`📍 Found ${pickerStores.length} stores in picker`);
        
        // Log first 5 picker store IDs and names
        console.group('Store Picker Items (first 5):');
        Array.from(pickerStores).slice(0, 5).forEach((item, index) => {
            console.log(`${index + 1}. ID: "${item.dataset.storeId}" | Name: "${item.dataset.storeName}"`);
        });
        console.groupEnd();
        
        // Log first 5 store locator items
        if (window.storeLocations && window.storeLocations.length > 0) {
            console.group('Store Locator Items (first 5):');
            window.storeLocations.slice(0, 5).forEach((store, index) => {
                console.log(`${index + 1}. ID: "${store.id}" | Name: "${store.name}" | Has coords: ${!!(store.coordinates && store.coordinates.lat && store.coordinates.lng)}`);
            });
            console.groupEnd();
        } else {
            console.warn('No storeLocations found in window object');
        }
        
        // Try to find matches
        console.group('🔗 Matching Analysis:');
        let matchCount = 0;
        Array.from(pickerStores).forEach(item => {
            const pickerId = item.dataset.storeId;
            const pickerName = item.dataset.storeName;
            
            // Try different matching strategies
            const exactIdMatch = window.storeLocations?.find(s => s.id === pickerId);
            const nameMatch = window.storeLocations?.find(s => s.name === pickerName);
            const partialNameMatch = window.storeLocations?.find(s => 
                s.name.toLowerCase().includes(pickerName.toLowerCase()) || 
                pickerName.toLowerCase().includes(s.name.toLowerCase())
            );
            
            if (exactIdMatch || nameMatch || partialNameMatch) {
                matchCount++;
                console.log(`✅ Match found for "${pickerName}"`);
            } else {
                console.warn(`❌ No match for "${pickerName}" (ID: ${pickerId})`);
            }
        });
        console.log(`\n📊 Summary: ${matchCount}/${pickerStores.length} stores matched`);
        console.groupEnd();
        
        console.groupEnd();
    }, 3000);
});